import { IconsVariant } from "@/Components/Icon/Icon";
import { CountryCode } from "./enum";

export type Countries = "NETHERLANDS" | "BELGIUM" | "TURKIYE";
type CountryCodes = "NL" | "BE" | "TR";

export type CountryCodesNum =
  | CountryCode.NETHERLANDS
  | CountryCode.BELGIUM
  | CountryCode.TURKIYE;

type CountriesItem = {
  value: CountryCodesNum;
  label: string;
  code: CountryCodes;
  icon: IconsVariant;
  phonePrefix: string;
};

export const countries: CountriesItem[] = [
  {
    value: CountryCode.NETHERLANDS,
    label: "netherlands",
    code: "NL",
    icon: "nl",
    phonePrefix: "+31",
  },
  {
    value: CountryCode.BELGIUM,
    label: "belgium",
    code: "BE",
    icon: "belgium",
    phonePrefix: "+31",
  },
  {
    value: CountryCode.TURKIYE,
    label: "turkiye",
    code: "TR",
    icon: "tr",
    phonePrefix: "+90",
  },
];

export const codeToCountry: Record<CountryCodesNum, Countries> = {
  [CountryCode.NETHERLANDS]: "NETHERLANDS",
  [CountryCode.BELGIUM]: "BELGIUM",
  [CountryCode.TURKIYE]: "TURKIYE",
};

export const codeToCountryIcon: Record<CountryCodesNum, IconsVariant> = {
  [CountryCode.NETHERLANDS]: "nl",
  [CountryCode.BELGIUM]: "belgium",
  [CountryCode.TURKIYE]: "turkiye",
};
